import * as Yup from "yup";
import ValidationConfiguration from "../../../hooks/change-tracker/ValidationConfiguration";
import TrackerName from "./FinancingRequestValidityRangeTrackerName";
import FinancingRequestValidityRangeStudentData from "./FinancingRequestValidityRangeStudentData";
import ValidityRangeReason from "./ValidityRangeReason";
import { isSchoolWithdrawalMonth } from "../../../utilities/utilities";

const defineStudentDataValidationConfig = (
  hasChanged: boolean
): ValidationConfiguration => {
  const config = {
    trackerName: TrackerName.ValidityRange,
    validationScheme: Yup.array()
      .of(
        Yup.object<FinancingRequestValidityRangeStudentData[]>()
          .shape({
            validTo: Yup.date().nullable(),
            validityRangeReason: Yup.number().nullable()
          })
          .test(
            "ValidityRange",
            "Potrebno je odabrati sve podatke za učenika",
            function(studentData: FinancingRequestValidityRangeStudentData) {
              const { path, createError } = this;

              if (
                (studentData.validTo &&
                  studentData.validityRangeReason == null &&
                  !isSchoolWithdrawalMonth(studentData)) ||
                (studentData.validTo == null && studentData.validityRangeReason)
              ) {
                return createError({
                  path: path,
                  message: "Potrebno je odabrati sve podatke za učenika"
                });
              }
              return true;
            }
          )
      )
      .test(
        "ValidityRange",
        "Potrebno je odabrati barem jednog učenika",
        function(studentsData: FinancingRequestValidityRangeStudentData[]) {
          const { path, createError } = this;

          if (studentsData && studentsData.length > 0) {
            const changedStudents = studentsData.filter(sd => sd.validTo);

            if (changedStudents.length == 0 || !hasChanged) {
              return createError({
                path: path || "",
                message: "Potrebno je odabrati barem jednog učenika"
              });
            }
          }

          return true;
        }
      )
  } as ValidationConfiguration;

  return config;
};

export const getValidationConfigurations = (
  hasChanged: boolean
): ValidationConfiguration[] => {
  return [defineStudentDataValidationConfig(hasChanged)];
};
